<template>
  <div class="foo">
    <div id="fucklogin">
      <el-row class="fucko">
        <el-col :span="18">
          <h1 class="title">PLOYQ Center</h1>
        </el-col>
      </el-row>
      <el-row class="fucko">
        <el-col :span="18">
          <el-input v-model="input_username" placeholder="username">
            <template slot="prepend">账号:</template>
          </el-input>
        </el-col>
      </el-row>

      <el-row class="fucko">
        <el-col :span="18">
          <el-input v-model="input_passwd" type="password" placeholder="password">
            <template slot="prepend">密码:</template>
          </el-input>

          <el-button class="fucko" type="primary" @click="loginii" plain>Login[登录]</el-button>
          <el-button class="fucko" type="primary" @click="isshowgonggao=true" plain>公告</el-button>
        </el-col>
      </el-row>
    </div>
    <el-dialog
        title="------------------------------★★★★★★★★★★★★★★★★★★★★★★★★★★★------------------------------------"
        :visible.sync="isshowgonggao"
        width="30%" >
        <h1><span style="color: red;" >重要公告：</span></h1>
        <h2>使用4G流量卡的用户 很抱歉，中国电信 要求 所有流量卡都要实名到终端用户，所以 请联系我们 提交信息 否则电信在 3月1日 会给于 拆机处理！！<span style="color: red;">【拆机后流量卡不可恢复】</span> 联系微信/电话：17501480262 </h2>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="isshowgonggao = false">确 定</el-button>
        </span>
    </el-dialog>
    <div>
       <!-- <p style="color: #FFFFFF;">无锡小播鼠网络科技有限公司</p> -->
        <a  style="color: #FFFFFF;" href=" " target="_blank">VV1备案号:</a >
        <a  style="color: #FFFFFF;" href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2021010349号-1</a >
    </div>
  </div>

</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      input_passwd: "",
      input_username: "",
      isshowgonggao:true
    };
  },
  created() {


    if (this.Pass && this.Phone) {
      sessionStorage.removeItem("token");
      let base1s = hpps1 + "user/checkin.boxuds";
      let phone = this.Phone;
      let pass = this.Pass;
      axios
        .post(
          base1s,
          {
            action: "user/checkin",
            params: {
              login_id: phone,
              passwd: pass,
              type: 0
            }
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(
          function(res) {
            if (res.data.code == 8200) {
              console.log(res.data.result.token);
              sessionStorage.setItem("token", res.data.result.token);
              this.$router.push({ path: "/" });
            } else {
              alert(res.data.msg);
            }
          }.bind(this)
        )
        .catch(function(error) {
          alert("error: " + error);
        });
    }


	 console.log(this.$router.currentRoute.query.username);
	console.log(this.$router.currentRoute.query.passwd);
	if(this.$router.currentRoute.query.passwd  != undefined && this.$router.currentRoute.query.passwd != undefined ){
			 console.log("传参传入了账号密码");
			 axios
			   .get("/checkuser.php", {
			     params: {
			       passwd: this.$router.currentRoute.query.passwd,
			       username: this.$router.currentRoute.query.username
			     }
			   })
			   .then(
			     function(res) {
			       if (res.data.res) {
			         sessionStorage.setItem("token", this.input_passwd);
			         sessionStorage.setItem("username", res.data.user_name);
			         sessionStorage.setItem("id", res.data.id);
			         sessionStorage.setItem("passwd", res.data.user_pass);
			         sessionStorage.setItem("user_type", res.data.user_type);
			         sessionStorage.setItem("master_id", res.data.master_id);
			         sessionStorage.setItem("mask", res.data.mask);
			         sessionStorage.setItem("play_level", res.data.play_level);
			         sessionStorage.setItem("user_level", res.data.user_level);
			         this.$router.push({ path: "/aaa" });
			         this.$notify.success({
			           title: "Info",
			           message: "验证通过",
			           showClose: false
			         });
			       } else {
			         this.$notify.success({
			           title: "Info",
			           message: "验证不通过",
			           showClose: false
			         });
			       }
			     }.bind(this)
			   )
			   .catch(function(res) {
			     console.log(res);
			   });

	}else{
			 console.log("没有传入账号密码");
	}
  },
  methods: {
    loginii() {
      axios
        .get("/checkuser.php", {
          params: {
            passwd: this.input_passwd,
            username: this.input_username
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              sessionStorage.setItem("token", this.input_passwd);
              sessionStorage.setItem("username", res.data.user_name);
              sessionStorage.setItem("id", res.data.id);
              sessionStorage.setItem("passwd", res.data.user_pass);
              sessionStorage.setItem("user_type", res.data.user_type);
              sessionStorage.setItem("master_id", res.data.master_id);
              sessionStorage.setItem("mask", res.data.mask);
              sessionStorage.setItem("play_level", res.data.play_level);
              sessionStorage.setItem("user_level", res.data.user_level);
              this.$router.push({ path: "/aaa" });
              this.$notify.success({
                title: "Info",
                message: "验证通过",
                showClose: false
              });
            } else {
              this.$notify.success({
                title: "Info",
                message: "验证不通过",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    gologin() {
      sessionStorage.removeItem("token");
      let base1s = hpps1 + "user/checkin.boxuds";
      let phone = this.tel;
      let pass = this.pass;
      if (this.radio == 1) {
        sessionStorage.setItem("phone", phone);
        sessionStorage.setItem("pass", pass);
      }
      axios
        .post(
          base1s,
          {
            action: "user/checkin",
            params: {
              login_id: phone,
              passwd: pass,
              type: 0
            }
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(
          function(res) {
            if (res.data.code == 8200) {
              console.log(res.data.result.token);
              sessionStorage.setItem("token", res.data.result.token);
              this.$router.push({ path: "/" });
            } else {
              alert(res.data.msg);
            }
          }.bind(this)
        )
        .catch(function(error) {
          alert("error: " + error);
        });
    }
  },
  computed: {
    Phone() {
      return sessionStorage.getItem("phone");
    },
    Pass() {
      return sessionStorage.getItem("pass");
    }
  }
};
</script>

<style lang="scss" scoped>
.foo {
  width: 100%;
  height: 100%;
  background: url(../assets/login_bg.jpg);
  position: fixed;
	background-repeat:no-repeat;
	 background-position: 0px 0px;
		background-size:100% 100%;
}
.title {
  color: white;
}
.fucko {
  margin-top: 10px;
}
#fucklogin {
  margin: 15% auto;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/Foo.vue